import Grid from '@mui/material/Grid';


export default function SectionDashboardBlood({
    colorContainer = "transparent",
    sections = [],
    gap = 0,          // default spacing between items (theme.spacing(2))
    padding = 0,      // default inner padding (theme.spacing(2))
    }) {


return (

    <Grid container 
                
                backgroundColor={colorContainer} 
                display='flex' 
                justifyContent='center'
                alignItems='center' 
                margin= 'auto' 
                spacing={gap} // <-- adds spacing between items
                sx={{ width: { xs: "100%", sm:"75%", lg: "55%", xl: "43%" }, p: padding, }}
                >

            {sections.map((section, index) => (
                
                <Grid 
                size={12}
                key={index}
                bgcolor={section.color}
                borderRadius='8px'
                marginBottom={2}
                >
                {section.content}
                </Grid>
            ))}
    </Grid>
  );
}